import apiStock from '../../../api/stock';
import apiOption from '../../../api/option';

const defaultState = () => ({
	optionWarehouse: [],
	listStock: [],
	stockPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	setStock(state, data) {
		state.listStock = data.data
		state.stockPagination = data.pagination;
	},
	saveResponse(state, data) {
		state.response = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	}
};

const actions = {
	getOptionWarehouse({ commit }, params) {
		apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
			commit('setOptionWarehouse', data.results);
		}).catch(() => {
			commit('setOptionWarehouse', []);
		});
	},
	getStock({ commit }, params) {
		apiStock.getStock(params).then(({ data: { data } }) => {
			commit('setStock', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setStock', { data: [], pagination: {} });
		});
	},
	getStockAll({ commit }, params) {
		apiStock.getStockAll(params).then(({ data: { data } }) => {
			commit('setStock', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setStock', { data: [], pagination: {} });
		});
	},
	getStockLog({ commit }, params) {
		apiStock.getStockLog(params).then(({ data: { data } }) => {
			commit('setStock', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setStock', { data: [], pagination: {} });
		});
	},
	getStockLogAll({ commit }, params) {
		apiStock.getStockLogAll(params).then(({ data: { data } }) => {
			commit('setStock', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setStock', { data: [], pagination: {} });
		});
	},
	async exportStock({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStock.exportStock(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data stok produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportStockAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStock.exportStockAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data stok warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportStockLog({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStock.exportStockLog(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data stok mutasi produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportStockLogAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStock.exportStockLogAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data stok mutasi warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};